<template>
    <div class="quick-link-manager-page">
        <el-card v-if="embedded" shadow="never">
            <el-tabs v-model="activeEmbeddedTab" type="card" class="quick-link-manager-page__tabs">
                <el-tab-pane label="税务快登" name="tax" lazy>
                    <div class="quick-link-manager-page__tax-top-actions">
                        <div class="quick-link-manager-page__header-actions">
                            <el-button type="primary" size="small" :loading="autoConfiguringTax" @click="autoConfigureTaxLinks">自动匹配全国税务入口</el-button>
                        </div>
                    </div>
                    <el-table :data="taxLinks" border stripe v-loading="loading">
                        <el-table-column prop="province" label="省份" min-width="120" />
                        <el-table-column prop="url" label="链接地址" min-width="300" />
                        <el-table-column prop="sort_order" label="排序" min-width="80" />
                        <el-table-column label="状态" min-width="90">
                            <template slot-scope="{ row }">
                                <el-tag :type="row.status === 1 ? 'success' : 'info'" size="small">
                                    {{ row.status === 1 ? '启用' : '停用' }}
                                </el-tag>
                            </template>
                        </el-table-column>
                        <el-table-column label="操作" min-width="120" fixed="right">
                            <template slot-scope="{ row }">
                                <el-button type="text" size="mini" @click="openEditDialog(row)">编辑</el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                </el-tab-pane>
                <el-tab-pane label="工商快登" name="industry" lazy>
                    <div class="quick-link-manager-page__header quick-link-manager-page__header--inner quick-link-manager-page__header--only-actions">
                        <div class="quick-link-manager-page__header-actions">
                            <el-button type="primary" size="small" :loading="autoConfiguringBiz" @click="autoConfigureBizLinks">自动配置全国注销一网平台</el-button>
                        </div>
                    </div>
                    <el-table :data="industryLinks" border stripe v-loading="loading">
                        <el-table-column prop="province" label="省份" min-width="120" />
                        <el-table-column prop="url" label="链接地址" min-width="300" />
                        <el-table-column prop="sort_order" label="排序" min-width="80" />
                        <el-table-column label="状态" min-width="90">
                            <template slot-scope="{ row }">
                                <el-tag :type="row.status === 1 ? 'success' : 'info'" size="small">
                                    {{ row.status === 1 ? '启用' : '停用' }}
                                </el-tag>
                            </template>
                        </el-table-column>
                        <el-table-column label="操作" min-width="120" fixed="right">
                            <template slot-scope="{ row }">
                                <el-button type="text" size="mini" @click="openEditDialog(row)">编辑</el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                </el-tab-pane>
            </el-tabs>
        </el-card>

        <el-card v-if="!embedded" shadow="never">
            <div slot="header" class="quick-link-manager-page__header">
                <span>快登链接管理</span>
                <el-button type="primary" size="small" icon="el-icon-plus" @click="openCreateDialog()">新增链接</el-button>
            </div>

            <el-table :data="list" border stripe v-loading="loading">
                <el-table-column prop="province" label="省份" min-width="120" />
                <el-table-column label="类型" min-width="100">
                    <template slot-scope="{ row }">
                        {{ formatLinkType(row.link_type) }}
                    </template>
                </el-table-column>
                <el-table-column prop="url" label="链接地址" min-width="260" />
                <el-table-column prop="sort_order" label="排序" min-width="80" />
                <el-table-column label="状态" min-width="90">
                    <template slot-scope="{ row }">
                        <el-tag :type="row.status === 1 ? 'success' : 'info'" size="small">
                            {{ row.status === 1 ? '启用' : '停用' }}
                        </el-tag>
                    </template>
                </el-table-column>
                <el-table-column label="操作" min-width="120" fixed="right">
                    <template slot-scope="{ row }">
                        <el-button type="text" size="mini" @click="openEditDialog(row)">编辑</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </el-card>

        <el-dialog :title="editingId ? '编辑快登链接' : '新增快登链接'" :visible.sync="dialogVisible" width="560px">
            <el-form :model="form" label-width="100px">
                <el-form-item label="省份">
                    <el-input v-model.trim="form.province" class="full-width" placeholder="请输入省份，例如：广东省" />
                </el-form-item>
                <el-form-item label="类型">
                    <el-select v-model="form.link_type" class="full-width">
                        <el-option label="税务" :value="1" />
                        <el-option label="工商" :value="2" />
                        <el-option v-if="!embedded" label="爱企查" :value="3" />
                        <el-option v-if="!embedded" label="国家企业信用公示网" :value="4" />
                        <el-option v-if="!embedded" label="国家电子税务局" :value="5" />
                        <el-option v-if="!embedded" label="报价助手" :value="6" />
                    </el-select>
                </el-form-item>
                <el-form-item label="链接地址">
                    <el-input v-model.trim="form.url" />
                </el-form-item>
                <el-form-item label="排序">
                    <el-input-number v-model="form.sort_order" :min="1" class="full-width" />
                </el-form-item>
                <el-form-item label="状态">
                    <el-switch v-model="enabledFlag" active-text="启用" inactive-text="停用" />
                </el-form-item>
            </el-form>
            <span slot="footer">
                <el-button @click="dialogVisible = false">取消</el-button>
                <el-button type="primary" :loading="saving" @click="submitForm">保存</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
export default {
    name: 'QuickLinkManager',
    props: {
        embedded: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            loading: false,
            saving: false,
            dialogVisible: false,
            editingId: null,
            activeEmbeddedTab: 'tax',
            autoConfiguringTax: false,
            autoConfiguringBiz: false,
            list: [],
            form: {
                province: '广东省',
                link_type: 1,
                url: '',
                status: 1,
                sort_order: 1
            }
        };
    },
    created() {
        this.fetchList();
    },
    computed: {
        taxLinks() {
            return this.list.filter(function (item) {
                return Number(item.link_type) === 1;
            });
        },
        industryLinks() {
            return this.list.filter(function (item) {
                return Number(item.link_type) === 2;
            });
        },
        enabledFlag: {
            get() {
                return this.form.status === 1;
            },
            set(value) {
                this.form.status = value ? 1 : 0;
            }
        }
    },
    methods: {
        formatLinkType(linkType) {
            var map = {
                1: '税务',
                2: '工商',
                3: '爱企查',
                4: '国家企业信用公示网',
                5: '国家电子税务局',
                6: '报价助手'
            };
            return map[Number(linkType)] || '--';
        },
        fetchList() {
            var _this = this;
            this.loading = true;

            window.axios.get('/quick-links').then(function (response) {
                _this.list = response.data.data || [];
            }).finally(function () {
                _this.loading = false;
            });
        },
        openCreateDialog(linkType) {
            var initLinkType = typeof linkType === 'number' ? linkType : 1;
            this.editingId = null;
            this.form = {
                province: '广东省',
                link_type: initLinkType,
                url: '',
                status: 1,
                sort_order: 1
            };
            this.dialogVisible = true;
        },
        autoConfigureBizLinks() {
            var _this = this;
            this.$confirm('将按国家市场监督管理总局公布的各省企业注销「一网」平台入口自动写入（营业执照注销申报办理入口）。已存在省份会覆盖为默认入口，是否继续？', '自动配置确认', {
                type: 'warning'
            }).then(function () {
                _this.autoConfiguringBiz = true;
                var defaults = _this.getNationalBizDefaults();
                var requests = defaults.map(function (item) {
                    return window.axios.post('/quick-links', {
                        province: item.province,
                        link_type: 2,
                        name: item.province + '-工商快登',
                        url: item.url,
                        status: 1,
                        sort_order: 1
                    });
                });

                return Promise.all(requests).then(function () {
                    _this.$message.success('全国注销一网平台入口已自动配置');
                    _this.fetchList();
                });
            }).catch(function (err) {
                if (err === 'cancel') {
                    return;
                }
                var message = err && err.response && err.response.data && err.response.data.message
                    ? err.response.data.message
                    : '自动配置失败';
                _this.$message.error(message);
            }).finally(function () {
                _this.autoConfiguringBiz = false;
            });
        },
        autoConfigureTaxLinks() {
            var _this = this;
            this.$confirm('将按全国省级清单自动写入税务注销登录入口。已存在省份会覆盖为默认入口，是否继续？', '自动匹配确认', {
                type: 'warning'
            }).then(function () {
                _this.autoConfiguringTax = true;
                var defaults = _this.getNationalTaxDefaults();
                var requests = defaults.map(function (item) {
                    return window.axios.post('/quick-links', {
                        province: item.province,
                        link_type: 1,
                        name: item.province + '-税务快登',
                        url: item.url,
                        status: 1,
                        sort_order: 1
                    });
                });

                return Promise.all(requests).then(function () {
                    _this.$message.success('全国税务入口已自动匹配');
                    _this.fetchList();
                });
            }).catch(function (err) {
                if (err === 'cancel') {
                    return;
                }
                var message = err && err.response && err.response.data && err.response.data.message
                    ? err.response.data.message
                    : '自动匹配失败';
                _this.$message.error(message);
            }).finally(function () {
                _this.autoConfiguringTax = false;
            });
        },
        getNationalTaxDefaults() {
            return [
                { province: '北京市', url: 'https://etax.beijing.chinatax.gov.cn' },
                { province: '天津市', url: 'https://etax.tianjin.chinatax.gov.cn' },
                { province: '上海市', url: 'https://etax.shanghai.chinatax.gov.cn' },
                { province: '重庆市', url: 'https://etax.chongqing.chinatax.gov.cn' },
                { province: '河北省', url: 'https://etax.hebei.chinatax.gov.cn' },
                { province: '山西省', url: 'https://etax.shanxi.chinatax.gov.cn' },
                { province: '辽宁省', url: 'https://etax.liaoning.chinatax.gov.cn' },
                { province: '吉林省', url: 'https://etax.jilin.chinatax.gov.cn' },
                { province: '黑龙江省', url: 'https://etax.heilongjiang.chinatax.gov.cn' },
                { province: '江苏省', url: 'https://etax.jiangsu.chinatax.gov.cn' },
                { province: '浙江省', url: 'https://etax.zhejiang.chinatax.gov.cn' },
                { province: '安徽省', url: 'https://etax.anhui.chinatax.gov.cn' },
                { province: '福建省', url: 'https://etax.fujian.chinatax.gov.cn' },
                { province: '江西省', url: 'https://etax.jiangxi.chinatax.gov.cn' },
                { province: '山东省', url: 'https://etax.shandong.chinatax.gov.cn' },
                { province: '河南省', url: 'https://etax.henan.chinatax.gov.cn' },
                { province: '湖北省', url: 'https://etax.hubei.chinatax.gov.cn' },
                { province: '湖南省', url: 'https://etax.hunan.chinatax.gov.cn' },
                { province: '广东省', url: 'https://etax.guangdong.chinatax.gov.cn' },
                { province: '海南省', url: 'https://etax.hainan.chinatax.gov.cn' },
                { province: '四川省', url: 'https://etax.sichuan.chinatax.gov.cn' },
                { province: '贵州省', url: 'https://etax.guizhou.chinatax.gov.cn' },
                { province: '云南省', url: 'https://etax.yunnan.chinatax.gov.cn' },
                { province: '陕西省', url: 'https://etax.shaanxi.chinatax.gov.cn' },
                { province: '甘肃省', url: 'https://etax.gansu.chinatax.gov.cn' },
                { province: '青海省', url: 'https://etax.qinghai.chinatax.gov.cn' },
                { province: '内蒙古自治区', url: 'https://etax.neimenggu.chinatax.gov.cn' },
                { province: '广西壮族自治区', url: 'https://etax.guangxi.chinatax.gov.cn' },
                { province: '西藏自治区', url: 'https://etax.xizang.chinatax.gov.cn' },
                { province: '宁夏回族自治区', url: 'https://etax.ningxia.chinatax.gov.cn' },
                { province: '新疆维吾尔自治区', url: 'https://etax.xinjiang.chinatax.gov.cn' },
                { province: '香港特别行政区', url: 'https://www.ird.gov.hk' },
                { province: '澳门特别行政区', url: 'https://www.dsf.gov.mo' },
                { province: '台湾省', url: 'https://www.etax.nat.gov.tw' }
            ];
        },
        /**
         * 各省「企业注销一网」办理入口，来源：国家市场监督管理总局「企业注销便利化」专题
         * https://www.samr.gov.cn/zt/ndzt/2019n/qyzxblh/index.html （各地注销「一网」平台栏目）
         * 港澳台未列入该栏目，保留常用官方商事登记/办事指引链接，便于人工在后台改链。
         */
        getNationalBizDefaults() {
            return [
                { province: '北京市', url: 'https://ect.scjgj.beijing.gov.cn' },
                { province: '天津市', url: 'https://zwfw.tj.gov.cn/tj_twfw/page/index.html?record=istrue' },
                { province: '上海市', url: 'https://yct.sh.gov.cn/repeal_yct_portal/webcancel/progress_etps_login.do' },
                { province: '重庆市', url: 'https://zwykb.cq.gov.cn/' },
                { province: '河北省', url: 'https://www.hbzwfw.gov.cn/col/col21137/index.html' },
                { province: '山西省', url: 'https://1.71.190.115:8081/repeal/index' },
                { province: '辽宁省', url: 'https://www.lnzwfw.gov.cn/' },
                { province: '吉林省', url: 'http://e.jlgs.gov.cn:19050/' },
                { province: '黑龙江省', url: 'https://www.zwfw.hlj.gov.cn/yswz/f/qyzx' },
                { province: '江苏省', url: 'http://218.94.38.242:56666/allChainLink/jsp/index.jsp' },
                { province: '浙江省', url: 'https://gswsdj.zjzwfw.gov.cn/entrance_zxywt.html' },
                { province: '安徽省', url: 'https://www.ahzwfw.gov.cn/qyzx-web/index.html' },
                { province: '福建省', url: 'http://61.154.11.191/repeal_yct_portal' },
                { province: '江西省', url: 'http://fw.amr.jiangxi.gov.cn/pages/ywtb_grindex.html' },
                { province: '山东省', url: 'http://zwfw.sd.gov.cn/sdzw/items/qysl/detail.do?code=qyzx' },
                { province: '河南省', url: 'http://222.143.21.61:9080/cancelFacilit/cancelIndex.action' },
                { province: '湖北省', url: 'https://zwfw.hubei.gov.cn/' },
                { province: '湖南省', url: 'http://222.240.225.75:8069/repeal_yct_portal/' },
                { province: '广东省', url: 'https://qyzx.gdzwfw.gov.cn/' },
                { province: '海南省', url: 'https://e-register.amr.hainan.gov.cn/ICPSP/' },
                { province: '四川省', url: 'http://182.131.3.112:8069/repeal_yct_portal/' },
                { province: '贵州省', url: 'https://zwfw.guizhou.gov.cn/eptemp.aspx?t=Znzw.other.qyzxPage&istest=1&areacode=520000' },
                { province: '云南省', url: 'http://gsxt.ynaic.gov.cn/repeal_yct_portal/' },
                { province: '陕西省', url: 'http://snamr.shaanxi.gov.cn:7107/' },
                { province: '甘肃省', url: 'http://117.156.54.233' },
                { province: '青海省', url: 'http://218.95.241.39:9045/ICPSP/cancelFacilit/cancelIndex.action' },
                { province: '内蒙古自治区', url: 'http://amr.nmg.gov.cn:27001' },
                { province: '广西壮族自治区', url: 'https://zwfw.gxzf.gov.cn/gxzwfw/appserver/qyzx.do' },
                { province: '西藏自治区', url: 'https://www.xzzwfw.gov.cn/logout/companyLogout.shtml?siteId=1' },
                { province: '宁夏回族自治区', url: 'http://wszc.nxscjg.cn:9071/ICPSP/cancelFacilit/cancelIndex.action' },
                { province: '新疆维吾尔自治区', url: 'http://sjyw.xjaic.gov.cn:8088/entservice/api/v1.0/index' },
                { province: '香港特别行政区', url: 'https://www.gov.hk/tc/business/registration/close.htm' },
                { province: '澳门特别行政区', url: 'https://www.gov.mo/zh-hant/entity/categories/business-and-commerce/' },
                { province: '台湾省', url: 'https://findbiz.nat.gov.tw' }
            ];
        },
        openEditDialog(row) {
            this.editingId = row.id;
            this.form = {
                province: row.province,
                link_type: row.link_type,
                url: row.url,
                status: row.status,
                sort_order: row.sort_order
            };
            this.dialogVisible = true;
        },
        submitForm() {
            var _this = this;
            this.form.province = (this.form.province || '').trim();

            if (!this.form.province) {
                this.$message.error('请输入省份');
                return;
            }

            var request = this.editingId
                ? window.axios.put('/quick-links/' + this.editingId, this.form)
                : window.axios.post('/quick-links', this.form);

            this.saving = true;

            request.then(function () {
                _this.$message.success('快登链接保存成功');
                _this.dialogVisible = false;
                _this.fetchList();
            }).catch(function (error) {
                var message = error && error.response && error.response.data && error.response.data.message
                    ? error.response.data.message
                    : '快登链接保存失败';
                _this.$message.error(message);
            }).finally(function () {
                _this.saving = false;
            });
        }
    }
};
</script>

<style scoped>
.quick-link-manager-page {
    padding: 0;
}

.quick-link-manager-page__header {
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.quick-link-manager-page__header-actions {
    display: flex;
    align-items: center;
    gap: 8px;
}

.quick-link-manager-page__header--inner {
    margin-bottom: 10px;
}

.quick-link-manager-page__header--only-actions {
    justify-content: flex-end;
}

.quick-link-manager-page__tax-top-actions {
    display: flex;
    justify-content: flex-end;
    margin-bottom: 8px;
}

.quick-link-manager-page__tabs /deep/ .el-tabs__content {
    padding-top: 10px;
}

.full-width {
    width: 100%;
}
</style>



// WEBPACK FOOTER //
// resources/assets/js/views/QuickLinkManager.vue